import { render, staticRenderFns } from "./editModelRoom.vue?vue&type=template&id=fc11c2a8&scoped=true"
import script from "./editModelRoom.vue?vue&type=script&lang=js"
export * from "./editModelRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc11c2a8",
  null
  
)

export default component.exports